import type {
  Profile,
  ProfileResponse,
  BusinessProfileResponse,
} from "@/schemas";
import {
  ProfileResponseSchema,
  BusinessProfileResponseSchema,
} from "@/schemas";

import { apiRequest } from "./apiUtils";

export async function getProfile(): Promise<ProfileResponse> {
  const data = await apiRequest<unknown>(`user/profile/info`, {
    method: "GET",
  });
  return ProfileResponseSchema.parse(data);
}

// Fetch any user's profile by userId
export async function getUserProfile(userId: string): Promise<ProfileResponse> {
  const data = await apiRequest<unknown>(
    `user/profile/info?user_id=${encodeURIComponent(userId)}`,
    {
      method: "GET",
    },
  );
  return ProfileResponseSchema.parse(data);
}

export async function updateProfile(
  profile: Partial<Profile>,
): Promise<ProfileResponse> {
  const data = await apiRequest<unknown>(`user/profile/update`, {
    method: "PATCH",
    body: JSON.stringify(profile),
  });
  return ProfileResponseSchema.parse(data);
}

// Employer -> get worker profile
export async function getWorkerProfileForEmployer(
  userId: string,
): Promise<ProfileResponse> {
  const data = await apiRequest<unknown>(`business/get-worker-info`, {
    method: "POST",
    body: JSON.stringify({ user_id: userId }),
  });
  return ProfileResponseSchema.parse(data);
}

// Worker -> get employer/business profile
export async function getEmployerProfileForWorker(
  businessId: number,
): Promise<BusinessProfileResponse> {
  const data = await apiRequest<unknown>(`worker/get-business-info`, {
    method: "POST",
    body: JSON.stringify({ business_id: businessId }),
  });
  return BusinessProfileResponseSchema.parse(data);
}
